import type { RouteObject } from "react-router-dom";
import { routePaths } from "src/admin/modules/stock-move/constants.ts";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";

const createRouteObject: RouteObject = {
  path: routePaths.create.root,
  lazy: () => import("./routes/create/create.route.tsx"),
};

export const module: Module = {
  id: ResourceEnum.StockMove,
  name: (t: TFunction) => t("moduleName.inventory-move"),
  bigIcon: <i className={"icon-20-mov_gds"} />,
  smallIcon: <i className={"icon-15-mov_gds"} />,
  disableEdit: true,
  disableDelete: true,

  create: {
    routeObject: createRouteObject,
  },
};
